export default __webpack_public_path__ + "static/media/b_loading-alpha (1).a5f838c7.gif";